import { useState } from "react";
import "./ApproveDeclined.scss";
import { FaPlus } from "react-icons/fa";

export default function ApproveDeclined({ onClose, handleApprove }) {
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExt = ["jpg", "jpeg", "png", "heic", "heif", "webp"];

    const ext = file.name.split(".").pop().toLowerCase();

    if (!allowedExt.includes(ext)) {
      setSelectedFile(null);
      setPreview(null);
      alert("Please upload a valid image (JPG, PNG, HEIC, WEBP)");
      return;
    }

    setSelectedFile(file);

    // Preview only if browser supports it
    if (file.type.startsWith("image/") && ext !== "heic" && ext !== "heif") {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null); // HEIC can't preview
    }
  };

  return (
    <div className="cancelform-container">
      <h2>APPROVE ORDER</h2>
      <span className="info">Upload receipt as proof of payment.</span>

      <div className={`upload-panel-wrapper ${preview ? "hasUpload" : ""}`}>
        {preview ? (
          <div className="preview-wrapper">
            <img src={preview} alt="Receipt Preview" />
          </div>
        ) : null}

        <label className="upload-btn">
          <input
            type="file"
            accept="image/*,.heic,.heif,.webp"
            onChange={handleFileChange}
            hidden
          />
          <span>
            <FaPlus />
          </span>
          UPLOAD RECEIPT
        </label>

        <span>Allowed: .JPG .JPEG .PNG</span>
      </div>

      <div className="button-wrapper">
        <button className="cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="submit" onClick={() => handleApprove(selectedFile)}>
          Submit
        </button>
      </div>
    </div>
  );
}
